import { makeStyles } from "@fluentui/react-components";

export const useClauseCardSideActionStyles = makeStyles({
  clauseCardSideActionContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "5px",
  },
  expandedButton: {
    marginTop: "auto",
  },
});
